import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileSettingsRoutingModule } from './profile-settings-routing.module';
import { ProfileSettingsComponent } from './profile-settings.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../../../shared/shared.module';
import { StickybarComponent } from '../../../components/stickybar/stickybar';
import { SubHeaderComponent } from '../../../components/sub-header/sub-header';


@NgModule({
  declarations: [
    ProfileSettingsComponent
  ],
  imports: [
    CommonModule,
    StickybarComponent,
    SubHeaderComponent,
    ProfileSettingsRoutingModule,
    SharedModule,
    NgxIntlTelInputModule,
    NgxSpinnerModule
  ],
  exports:[ProfileSettingsComponent]
})
export class ProfileSettingsModule { }
